import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Data2Service } from 'src/app/common/data2.service';
import { FocustipService } from 'src/app/common/focustip/focustip.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';

import { MapComponent } from 'src/app/common/map/map.component';
import { MapService } from 'src/app/common/map/map.service';

import { TransportsMapTemplatesComponent } from './transports-map-templates/transports-map-templates.component';

@Component({
	selector: 'app-transports-map',
	templateUrl: './transports-map.component.html',
	styleUrls: ['./transports-map.component.css'],
})
export class TransportsMapComponent implements OnInit {
	@ViewChild(MapComponent) mapComponent: MapComponent;
	@ViewChild(TransportsMapTemplatesComponent)
	transportsMapTemplatesComponent: TransportsMapTemplatesComponent;
	private itemsBeforeDataLoad = 2;
	private questionsetResetSubscription;

	map: Array<any> = [];
	data: Transport = {
		id: null,
		side: null,
		name: null,
		seasons: [],
		stops: null,
	};

	constructor(
		private readonly api: Data2Service,
		private readonly loader: LoaderService,
		private readonly infobox: InfoboxService,
		private readonly question: QuestionService,
		private readonly focustip: FocustipService,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
		public service: MapService,
	) {}

	ngOnInit(): void {
		this.data.id = this.route.snapshot.params['id'];
		this.data.side = this.route.snapshot.params['side'];
		this.loader.show();
		this.service.reset();
		this.loadBefore();
	}

	private loadBefore() {
		this.api.get('/vehicles/?vehicle_status=4', (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			result.data = result.data.map((item) => {
				item.destinations = [];
				item.type = 'vehicle';
				return item;
			});
			this.service.vehiclesAll = result.data;
			this.loadData();
		});
		this.api.get('/bag/bagTransports/' + this.data.id, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.data = result.data;
			this.loadData();
		});
	}

	private loadData() {
		if (!this.data.id) {
			this.loader.hide();
			return;
		}
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.loadDestinations();
	}

	private loadDestinations() {
		this.api.get('/bag/bagTransportsDestinations/' + this.data.id, (result, error) => {
			this.service.destinations = result.data.map((destination) => {
				destination.from = [];

				return destination;
			});
			console.log(this.service.destinations);
			this.loadTransportStops();
		});
	}

	private loadTransportStops() {
		this.api.get('/bag/bagStops/', (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			result.data = result.data.map((item) => {
				item.destinations = [];
				this.service.destinations.forEach((destination) => {
					destination = JSON.parse(JSON.stringify(destination));
					destination.originCity = item.id;
					item.destinations.push(destination);
				});
				return item;
			});
			this.loader.hide();

			this.service.cities = result.data;
			this.api.get('/bag/bagTransportsStops/?transport=' + this.data.id, (result, error) => {
				this.service.stops = {
					CR: [],
					DO: [],
				};
				result.data.forEach((element) => {
					const city = this.service.cities.find((obj) => obj.id == element.city);
					this.service.stopToggle({
						type: city.type,
						data: city,
					});
				});
			});
			this.mapComponent.generateMap();
			this.loadSeasons();
		});
	}

	private loadSeasons() {
		this.api.get('/bag/bagTransportsSeasons/?transport=' + this.data.id, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.data.seasons = result.data.map((obj) => {
				return obj.season;
			});
			this.loadLogic();
		});
	}

	private loadLogic() {
		this.api.get('/bag/bagTransportsLogic/?transport=' + this.data.id, (result, error) => {
			this.loader.hide();
			if (error) {
				return;
			}
			if (!result.data || !result.data.length) {
				this.openTemplates();
				return;
			}
			this.service.parse(result.data);
			// this.canSave = false
			if (this.service.vehicles.length) {
				this.service.selectVehicle(this.service.vehicles[0]);
			}
		});
	}

	openTemplates(): void {
		this.transportsMapTemplatesComponent.open(this.data.id, this.data.side, this.data.seasons);
	}

	templateSelected(): void {
		this.loader.show();
		this.loadData();
	}

	resetAll(): void {
		this.question.ask('Czy na pewno usunąć wszystkie połączenia i wybrane pojazdy?', 'resetAsk');
		this.questionsetResetSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'resetAsk') {
				return;
			}
			this.questionsetResetSubscription.unsubscribe();
			if (!result.result) {
				return;
			}
			this.api.del('/bag/bagTransportsLogic/' + this.data.id + '/', (result, error) => {
				this.api.del('/bag/bagTransportsTimetable/' + this.data.id + '/', (result, error) => {
					location.reload();
				});
			});
		});
	}

	submit(): void {
		if (!this.checkIfAllVehiclesHaveTarget()) {
			return;
		}
		if (!this.data.name) {
			this.focustip.show(document.getElementById('transportsName'), 'Nazwa nie została wypełniona');
			return;
		}
		this.loader.show();
		this.api.put('/bag/bagTransports/' + this.data.id, this.data, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.submitStops();
			this.submitTransports();
		});
	}

	private checkIfAllVehiclesHaveTarget(): boolean {
		let allHaveTarget = true;
		this.service.vehicles.forEach((vehicle) => {
			if (!this.service.havePeople(vehicle)) {
				return;
			}
			if (this.service.haveTarget(vehicle)) {
				return;
			}
			this.infobox.error('Brak przystanku docelowego dla: ' + vehicle.name);
			allHaveTarget = false;
		});
		return allHaveTarget;
	}

	private submitTransports() {
		const transports = this.service.transports.map((transport) => {
			if (!transport.destination) {
				transport.destination = {
					id: this.service.transports.find((obj) => obj.destination).destination.id,
					originCity: transport.city.id,
				};
			}
			if (!transport.destination.id) {
				transport.destination.id = this.service.transports.find((obj) => obj.destination).destination.id;
			}
			if (!transport.destination.originCity) {
				transport.destination.originCity = transport.city.id;
			}
			return {
				transport: this.data.id,
				originCity: transport.destination.originCity,
				city: transport.city.id,
				vehicle: transport.vehicle.id,
				action: transport.action,
				destination: transport.destination.id,
			};
		});
		this.api.post('/bag/bagTransportsLogic/' + this.data.id, transports, (result, error) => {
			this.loader.hide();
			if (error) {
				return;
			}
			this.infobox.success('Zapisano');
			this.service.editable = false;
		});
	}

	nameUpdated(): void {
		if (this.data.name.length == 1) {
			this.focustip.hide();
		}
	}

	private submitStops() {
		const data = {
			CR: this.service.stops.CR.map((obj) => {
				return obj.id;
			}),
			DO: this.service.stops.DO.map((obj) => {
				return obj.id;
			}),
		};
		this.api.put('/bag/bagTransportsStops/' + this.data.id, data, (result, error) => {
			if (error) {
				return;
			}
		});
	}
}

interface Transport {
	id: number;
	side: string;
	name: string;
	seasons: Array<any>;
	stops: any;
}
